export default __webpack_public_path__ + "static/media/prag_bg.986740c3.png";